<template>
  <div v-click-outside="close" class="filter">
    <div :class="{ open: open }" class="filter-top" @click="open = !open">
      <span>
        {{ activeFilterText }}
        <span
          v-if="activeFilterId === 'invites' ? isExistInvites : isExistUnreadMessages[activeFilterId]"
          class="filter-top__badge"
        ></span>
      </span>
      <div class="filter-top__icon">
        <svg fill="currentColor" height="8" viewBox="0 0 12 8" width="12" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M0.292969 1.70712L1.70718 0.292908L6.00008 4.5858L10.293 0.292908L11.7072 1.70712L6.00008 7.41423L0.292969 1.70712Z"
          />
        </svg>
      </div>
    </div>
    <transition name="slide-up" mode="in-out">
      <div v-show="open" class="filter-bottom">
        <div class="filter-bottom__title">
          {{ $t('selectChatFilter') }}
        </div>
        <ul class="filter-list">
          <li @click="handleFilter('all')">
            <span>
              {{ $t('tabAllChats') }}
              <span v-if="isExistUnreadMessages['all']" class="filter-list__badge"></span>
            </span>
          </li>
          <li @click="handleFilter('invites')">
            <span>
              {{ $t('tabInvites') }}
              <span v-if="isExistInvites" class="filter-list__badge"></span>
            </span>
          </li>
          <li v-for="filter in filters" :key="filter.id" @click="handleFilter(filter.id)">
            <span>
              {{ filter.name }}
              <span v-if="isExistUnreadMessages[filter.id]" class="filter-list__badge"></span>
            </span>
            <div class="filter-list__actions">
              <span @click.stop="handleActionFilter(filter, 'update')">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  height="20px"
                  viewBox="0 0 24 24"
                  width="20px"
                  fill="=currentColor"
                >
                  <path d="M0 0h24v24H0V0z" fill="none" />
                  <path
                    d="M14.06 9.02l.92.92L5.92 19H5v-.92l9.06-9.06M17.66 3c-.25 0-.51.1-.7.29l-1.83 1.83 3.75 3.75 1.83-1.83c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.2-.2-.45-.29-.71-.29zm-3.6 3.19L3 17.25V21h3.75L17.81 9.94l-3.75-3.75z"
                  />
                </svg>
              </span>
              <span @click.stop="handleActionFilter(filter, 'delete')">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  height="20px"
                  viewBox="0 0 24 24"
                  width="20px"
                  fill="currentColor"
                >
                  <path d="M0 0h24v24H0V0z" fill="none" />
                  <path
                    d="M16 9v10H8V9h8m-1.5-6h-5l-1 1H5v2h14V4h-3.5l-1-1zM18 7H6v12c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7z"
                  />
                </svg>
              </span>
            </div>
          </li>
        </ul>
        <div class="filter-bottom__actions">
          <BaseButton @click="handleActionFilter({}, 'create')">
            {{ $t('addFilter') }}
          </BaseButton>
          <a href="#" @click.prevent="close">{{ $t('buttonCancel') }}</a>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import BaseButton from '@/components/_BaseButton'
import { mapGetters } from 'vuex'
import { partition, groupBy } from 'lodash'
import { chatNamesForBridge } from '@/helpers/variables'
import { parseRouterQueryParam, getCountUnreadMessages } from '@/helpers/index'

const otherThanBridge = ({ name }) => name !== chatNamesForBridge.whatsapp && name !== chatNamesForBridge.telegram
const withoutPincode = ({ properties }) => properties && !properties.pinCode

const byFilterWithUnreadMessages = (filter, user) => chat =>
  // eslint-disable-next-line eqeqeq
  filter.some(({ chatId }) => chatId == chat.id && getCountUnreadMessages(chat, user))

// eslint-disable-next-line no-unused-vars
const STATIC_FILTERS = {
  all: 'all',
  invites: 'invites'
}
export default {
  name: 'FilterSelect',
  components: {
    BaseButton
  },
  data () {
    return {
      open: false
    }
  },
  computed: {
    ...mapGetters({
      user: 'auth/user',
      chatList: 'entities/chats/myChats',
      matrixRooms: 'matrix/rooms',
      inviteMatrixRooms: 'matrix/inviteRooms',
      currentChats: 'filter/currentChats',
      filters: 'filter/filters',
      isLoadingFilters: 'filter/isLoadingFilters'
    }),
    activeFilterId () {
      return parseRouterQueryParam(this.$route.query.filter) || 'all'
    },
    activeFilterText () {
      // eslint-disable-next-line eqeqeq
      const currentFilter = this.filters.find(e => e.id == this.activeFilterId)
      if (currentFilter) {
        return currentFilter.name
      } else {
        const isStaticFilter = !!STATIC_FILTERS[this.activeFilterId]
        return isStaticFilter
          ? this.$t(`staticFilter_${STATIC_FILTERS[this.activeFilterId]}`)
          : this.$t(`staticFilter_${STATIC_FILTERS.all}`)
      }
    },
    isExistInvites () {
      return !!this.inviteMatrixRooms.length
    },
    isExistUnreadMessages () {
      let list = [...this.chatList.filter(withoutPincode), ...this.matrixRooms.filter(otherThanBridge)]
      // eslint-disable-next-line eqeqeq
      const [filterAll, filterOther] = partition(this.currentChats, ({ chatFilterId }) => chatFilterId == null)
      const map = groupBy(filterOther, ({ chatFilterId }) => chatFilterId)
      map.all = filterAll
      for (const filterId in map) {
        map[filterId] = list.some(byFilterWithUnreadMessages(map[filterId], this.user))
      }
      return map
    }
  },
  methods: {
    close () {
      this.open = false
    },
    async handleFilter (id) {
      try {
        await this.$router.replace({ name: this.$route.name, query: { ...this.$route.query, filter: id } })
      } catch (error) {
        if (error.name !== 'NavigationDuplicated') throw new Error(error)
      } finally {
        this.open = false
      }
    },
    handleActionFilter (filter = {}, type) {
      this.$modal.show('add-filter', {
        ...filter,
        type: type
      })
    }
  }
}
</script>
<style lang="scss" scoped>
$badgeSize: 10px;

.slide-up-enter-active,
.slide-up-leave-active {
  transition: transform 0.1s linear, opacity 0.1s linear;
  opacity: 1;
  transform: translateY(0);
}

.slide-up-enter,
.slide-up-leave-to {
  transition: transform 0.1s linear, opacity 0.1s linear;
  opacity: 0;
  transform: translateY(-10px);
}

.filter {
  position: relative;
  width: 100%;
  &-top {
    position: relative;
    padding: 0 10px;
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    font-size: 16px;
    font-weight: 600;
    text-align: center;
    align-items: center;
    border-bottom: 1px solid $border-color;
    color: $green;
    cursor: pointer;
    user-select: none;
    background: $white;
    z-index: 4;
    &__badge {
      background: $text-error;
      border-radius: 50%;
      height: $badgeSize;
      left: 100%;
      margin-left: 6px;
      padding: 0;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      width: $badgeSize;
    }
    &.open {
      svg {
        transform: rotateX(-180deg);
      }
    }
    > span {
      position: relative;
    }

    &__icon {
      position: absolute;
      top: 50%;
      right: 10px;
      transform: translateY(-50%);

      svg {
        transition: transform 0.1s ease;
        width: 16px;
        height: 11px;
      }
    }
  }
  &-list {
    max-height: 250px;
    overflow-y: auto;
    &__actions {
      display: none;
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
      justify-content: flex-end;
      align-items: center;
      background: $main-bg-dark;
      z-index: 2;
      span {
        display: block;
        padding: 3px;
        color: $darkTextColor;
        &:hover {
          color: $green;
        }
      }
      svg {
        width: 20px;
        height: 20px;
      }
    }
    &__badge {
      background: $text-error;
      border-radius: 50%;
      height: $badgeSize;
      left: 100%;
      margin-left: 6px;
      padding: 0;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      width: $badgeSize;
    }
    li {
      position: relative;
      text-align: center;
      padding: 10px 15px;
      cursor: pointer;
      transition: background 0.05s ease;
      font-size: 14px;
      font-weight: 500;
      &:hover {
        background: $main-bg-dark;
        .filter-list__actions {
          display: flex;
        }
      }
      > span {
        position: relative;
      }
    }
  }
  &-bottom {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background: $white;
    padding: 10px 0;
    border-left: 1px solid $border-color;
    border-bottom: 1px solid $border-color;
    box-shadow: 0 3px 10px rgba(0, 0, 0, 0.2);
    z-index: 3;
    &__title {
      font-size: 14px;
      color: $green;
      text-align: center;
      margin-bottom: 10px;
    }
    &__actions {
      margin-top: 20px;
      text-align: center;
      padding-bottom: 5px;
      button {
        margin: 0 auto;
        height: auto;
        width: auto;
        font-size: 14px;
        padding: 10px 30px;
      }
      a {
        margin-top: 8px;
        display: inline-block;
        font-weight: 500;
        transition: color 0.1s ease, border-color 0.1s ease;
        border-bottom: 1px solid transparent;
        &:hover {
          border-color: $green;
        }
      }
    }
  }
}
</style>
